<template>
  <div class="mb-4 space-y-2">
    <div class="flex items-end gap-2">
      <base-input label="Search Calendar" v-model="query" class="flex-grow" @keyup.enter="search" />
      <base-button class="flex-none" @click="search">Search</base-button>
    </div>
    <div class="flex gap-2 items-end">
      <base-input label="Month">
        <el-select :options="months" v-model="date.month" />
      </base-input>
      <base-input label="Year">
        <el-select :options="years" v-model="date.year" />
      </base-input>
      <base-button @click="goToDate" :disabled="!(date.month && date.year)">Go To Date</base-button>
    </div>
  </div>
</template>
<script>

import Form from '../../../components/Form'
export default {
  components: {
    ...Form
  },
  data() {
    return {
      query: '',
      date: {
        month: 1,
        year: 2024,
      },
      years: [],
      months: [
        {label: "Select...", value: 0},
        {label: "January", value: 1},
        {label: "February", value: 2},
        {label: "March", value: 3},
        {label: "April", value: 4},
        {label: "May", value: 5},
        {label: "June", value: 6},
        {label: "July", value: 7},
        {label: "August", value: 8},
        {label: "September", value: 9},
        {label: "October", value: 10},
        {label: "November", value: 11},
        {label: "December", value: 12},
      ],
    }
  },
  methods: {
    search() {
      this.$inertia.visit(route('cms.broadcast-calendar.search', {query: this.query}));
    },
    goToDate() {
      this.$inertia.visit(route('cms.broadcast-calendar.index', {'year-month': this.date.year.toString().concat('-', this.date.month.toString())}))
    },
  },
  mounted() {
    const d = new Date();
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('year-month')) {
      const yearMonth = urlParams.get('year-month').split('-');
      this.date.year = yearMonth[0];
      this.date.month = yearMonth[1];
    } else {
      this.date.month = d.getMonth()+1;
      this.date.year = d.getFullYear();
    }
    let startYear = d.getFullYear() - 20;
    const endYear = d.getFullYear() + 2;
    while (startYear < endYear) {
      this.years.push(startYear++);
    }
    this.years.reverse();
  }
}
</script>
